import React from 'react';
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormHelperText,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const RadioField = ({
  field,
  value,
  onChange,
  onBlur,
  error = false,
  disabled = false,
  ...props
}) => {
  const { t } = useTranslation();

  const handleChange = (event) => {
    const newValue = event.target.value === 'true' ? true : event.target.value === 'false' ? false : event.target.value;
    if (onChange) {
      onChange(field.name, newValue, event);
    }
  };

  const handleBlur = (event) => {
    if (onBlur) {
      onBlur(field.name, value, event);
    }
  };

  return (
    <FormControl
      component="fieldset"
      error={error}
      required={field.required}
      disabled={disabled}
      fullWidth={true}
      sx={{
        '& .MuiFormLabel-root': {
          fontSize: '1rem',
          fontWeight: 500,
          color: 'text.primary',
          marginBottom: 0.5,
        },
        '& .MuiRadioGroup-root': {
          gap: 0.5,
        },
        '& .MuiFormControlLabel-root': {
          margin: 0,
          marginRight: 2,
        },
        '& .MuiFormHelperText-root': {
          marginTop: 0.5,
          fontSize: '0.875rem',
          color: 'text.secondary',
        },
      }}
      {...props}
    >
      <FormLabel component="legend">
        {t(field.label)}
        {field.required && ' *'}
      </FormLabel>
      <RadioGroup
        name={field.name}
        value={value?.toString() || ''}
        onChange={handleChange}
        onBlur={handleBlur}
        row
      >
        {field.options?.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value.toString()}
            control={<Radio size="small" />}
            label={t(option.label)}
          />
        ))}
      </RadioGroup>
      {field.helperText && (
        <FormHelperText>
          {t(field.helperText)}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default RadioField; 